import React, { useEffect, useState } from "react";
import LedgerPageDashboardActive from "../../../../Components/Bilateral/LedgerPageDashboardActive/LedgerPageDashboardActive";
import { useDispatch } from "react-redux";
import { fetchActiveConnection } from "../../../../Redux/Slices/CapacitySlice";
import { useLocation } from "react-router-dom";
import { setActiveSubTabStore } from "../../../../Redux/Slices/activeSubTabSlice";

const LedgerPageDashboard = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [activeSubTab, setActiveSubTab] = useState("");
  const listingId = location?.search?.split("=")[1];
  const { from } = location.state || {};

  const aa = React.useCallback(
    (subTab) => {
      setActiveSubTab(subTab);
      dispatch(setActiveSubTabStore(subTab));
    },
    [dispatch]
  );

  useEffect(() => {
    let subTab = "";
    if (from === "accept") {
      subTab = "T&C Approval Requests";
    } else if (from === "final") {
      subTab = "T&C to initiate";
    } else if (!from) {
      subTab = "T&C to initiate";
    } else {
      subTab = "T&C to initiate";
    }
    aa(subTab);
  }, [dispatch, from, aa]);

  useEffect(() => {
    dispatch(
      fetchActiveConnection({
        curr: 0,
        capId: listingId,
        isTermsAccepted: null,
      })
    );
  }, [dispatch, listingId, activeSubTab]);

  return (
    <LedgerPageDashboardActive
      activeSubTab={activeSubTab}
      setActiveSubTab={aa}
    />
  );
};

export default LedgerPageDashboard;
